import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import idssStyle from "../../../Configuration/SharedStyling";
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import { Grid2 as Grid, Card, CardContent } from "@mui/material";
import BackNavigation from '../../Shared/BackNavigation';
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";
import LoadingDisplay from "../../Shared/Loading";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import ReportsService from "../../Services/ReportsService";
import { Redirect } from "react-router-dom";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

interface ISubmissionsDataSummaryReportState {
    hedisData: any;
    cahpsData: any;
    hosData: any;
    isLoading: boolean;
    redirect: boolean
}

type IStylesProps = WithStyles<typeof styles>;

// VIEW
class SubmissionsDataSummaryReportView extends React.Component<
    IGenericUserProps & IStylesProps,
    ISubmissionsDataSummaryReportState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            hedisData: [],
            cahpsData: [],
            hosData: [],
            isLoading: true,
            redirect: false
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private descriptionBodyTemplate = (rowData: any) => {
        const { classes } = this.props;
        if (this.findTerm(rowData.description, 'plan')
            || this.findTerm(rowData.description, 'audit')
            || this.findTerm(rowData.description, 'final')) {
            return <span className={`${classes.submissionsDataHighlight}`}>{rowData.description}</span>;
        }
        else {
            return rowData.description;
        }
    };

    private getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'description',
            header: 'Description',
            enableSorting: true,
            enableFiltering: true,
            Cell: ({ row }) => this.descriptionBodyTemplate(row.original),
        },
        {
            accessorKey: 'count',
            header: 'Count',
            enableSorting: true,
            enableFiltering: true,
        },
    ];

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }

        const { classes } = this.props;

        return (<>
            <Grid container={true} className={classes.mt2}>
                <Grid size={12}>
                    <Grid container={true} spacing={2}>
                        <Grid size={12}>
                            <BackNavigation text="Back to Reports" href="/reportspage" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid key={1} size={4} className={classes.gridDisplay}>
                    <Card className={classes.card}>
                        <CardContent>
                            {this.state.isLoading ? <LoadingDisplay /> :
                                <SharedMaterialReactTable
                                    data={this.state.hedisData}
                                    columns={this.getTableColumns()}
                                    title="Hedis"
                                    isLoading={false}
                                    enablePagination={false}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={false}
                                    enableRowActions={false}
                                    emptyMessage="No HEDIS data found."
                                />
                            }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid key={2} size={4} className={classes.gridDisplay}>
                    <Card className={classes.card}>
                        <CardContent>
                            {this.state.isLoading ? <LoadingDisplay /> :
                                <SharedMaterialReactTable
                                    data={this.state.cahpsData}
                                    columns={this.getTableColumns()}
                                    title="CAHPS"
                                    isLoading={false}
                                    enablePagination={false}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={false}
                                    enableRowActions={false}
                                    emptyMessage="No CAHPS data found."
                                />
                            }
                        </CardContent>
                    </Card>
                </Grid>
                <Grid key={3} size={4} className={classes.gridDisplay}>
                    <Card className={classes.card}>
                        <CardContent>
                            {this.state.isLoading ? <LoadingDisplay /> :
                                <SharedMaterialReactTable
                                    data={this.state.hosData}
                                    columns={this.getTableColumns()}
                                    title="HOS"
                                    isLoading={false}
                                    enablePagination={false}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={false}
                                    enableRowActions={false}
                                    emptyMessage="No HOS data found."
                                />
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </>
        );
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const retval: any | AjaxError = await firstValueFrom(
            ReportsService.GetSubmissionsDataSummary$(this.props.user)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            const hedisData = retval.filter(v =>
                !v.description.toLowerCase().includes("cahps") &&
                !v.description.toLowerCase().includes("hos")
            );
            const cahpsData = retval.filter(v =>
                v.description.toLowerCase().includes("cahps")
            );
            const hosData = retval.filter(v =>
                v.description.toLowerCase().includes("hos")
            );
            this.setState({
                hedisData: this.getData(hedisData),
                cahpsData: this.getData(cahpsData),
                hosData: this.getData(hosData)
            });
        }
        this.setState({ isLoading: false });
    }

    private getData(data: any): any {
        var mappedData = data.map(item => {
            return {
                description: item.description,
                count: item.count
            };
        });
        return mappedData;
    }

    private findTerm(value, term): boolean {
        if (value.toLocaleLowerCase().includes(term)) {
            return true;
        }
        return false;
    }
}

// REDUX CONTAINER
const SubmissionsDataSummaryReportPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(SubmissionsDataSummaryReportView);

// STYLES CONTAINER
const SubmissionsDataSummaryReportPage = withStyles(styles)(
    SubmissionsDataSummaryReportPageWithState
);

export default SubmissionsDataSummaryReportPage;
